/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
//import "./styles.css"

import React from "react"
import { ChakraProvider } from '@chakra-ui/react'
import { AuthProvider } from "./src/context/authContext"
import { ThemeProvider } from "./src/context/ThemeContext"
import LocalProvider from "./src/context/LocalContext"
import TokenProvider from "./src/context/TokenContext"
import { TokenDataProvider } from "./src/context/tokenDataContext"

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
    <TokenProvider>
      <ThemeProvider>
        <LocalProvider>
          <TokenDataProvider>
            <ChakraProvider>
              {element}
            </ChakraProvider>
          </TokenDataProvider>
        </LocalProvider>
      </ThemeProvider>
    </TokenProvider>
  </AuthProvider>
)
